const LAST_COMPANY_COOKIE = "last-company";

const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

export function setLastCompanyCookie(companyId: string) {
  // pi-admin reads this shared cookie to offer returning users their last company.
  document.cookie = `${LAST_COMPANY_COOKIE}=${encodeURIComponent(companyId)}; ${cookieAttributes()}`;
}

function parentCookieDomain(hostname: string) {
  if (hostname === "localhost" || hostname.includes(":") || /^[\d.]+$/.test(hostname)) {
    return null;
  }

  const parts = hostname.split(".");
  return parts.length > 2 ? parts.slice(1).join(".") : hostname;
}

function cookieAttributes() {
  const attributes = [`Path=/`, `Max-Age=${ONE_YEAR_SECONDS}`, "SameSite=Lax"];
  const domain = parentCookieDomain(window.location.hostname);
  if (domain) attributes.push(`Domain=${domain}`);
  if (window.location.protocol === "https:") attributes.push("Secure");
  return attributes.join("; ");
}
